import { render } from "./ClinicsFindHeader.vue?vue&type=template&id=6eb827e9&ts=true"
import script from "./ClinicsFindHeader.vue?vue&type=script&lang=ts"
export * from "./ClinicsFindHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__